import heroIMG from '../../assets/images/projects/luxHairNyc/hero.png';
import challengeIMG from '../../assets/images/projects/luxHairNyc/challenge.png';
import structureIMG from '../../assets/images/projects/luxHairNyc/structure.png';

import { projectAuthorData } from './projectAuthorData';

export const luxHairNycProject = {
    id: 4,
    slug: 'luxhairnyc',

    label: 'Shopify',
    category: 'Shopify Umsetzung',

    title: 'Lux Hair NYC',

    cardDescription:
        'Shopify-Shop für Hair Extensions mit klarer Produktstruktur, detaillierten Produktinformationen und mobiler Optimierung.',

    image: heroIMG,
    imageAlt: 'Lux Hair NYC Shopify Store Startseite',

    tags: ['UX/UI', 'Entwicklung', 'Shopify'],

    website: 'https://luxhairnyc.shop/',

    page: {
        seo: {
            title: 'Lux Hair NYC — Shopify-Umsetzung für einen Hair-Extensions Store | Nexon Digital Studio',

            description:
                'Shopify-Umsetzung für Lux Hair NYC mit Produktvarianten, Kategorien, detaillierten Produktinformationen und mobiler Store-Optimierung.',
        },

        hero: {
            subtitle:
                'Nexon Digital Studio entwickelt und verbessert Shopify-Shops für kleine Unternehmen, Marken und Online-Händler in Deutschland — klar strukturiert, technisch sauber und auf Online-Verkauf ausgerichtet.',

            title: ['SHOPIFY', 'ENTWICKLUNG'],

            text: 'Shopify-Erstellung, Theme-Anpassung, Relaunch und technische Umsetzung für Unternehmen, die online verkaufen möchten.',

            button: 'Anfrage senden',
        },

        intro: {
            title: 'Lux Hair NYC — Shopify-Umsetzung für einen Hair-Extensions Store',

            texts: [
                'Für Lux Hair NYC wurde ein Shopify-Store für hochwertige Slavic Hair Extensions technisch umgesetzt und strukturiert aufgebaut. Der Fokus lag auf klarer Produktpräsentation, übersichtlichen Produktkategorien, mobiler Darstellung und einer sauberen technischen Grundlage für den Online-Verkauf.',

                'Das Projekt zeigt, wie Nexon Digital Studio Shopify-Shops mit vielen Produktvarianten, Kategorien und Detailinformationen technisch unterstützt, verständlicher strukturiert und für Kunden besser nutzbar macht.',
            ],

            meta: [
                {
                    id: 1,
                    title: 'Shopify Store',
                    label: 'Projektart',
                },
                {
                    id: 2,
                    title: 'Hair Extensions',
                    label: 'Branche',
                },
                {
                    id: 3,
                    title: 'Kategorien',
                    label: 'Umfang',
                },
                {
                    id: 4,
                    title: 'Mobile Darstellung',
                    label: 'Fokus',
                },
            ],

            image: heroIMG,
            imageAlt: 'Lux Hair NYC Shopify Store Startseite',
        },

        challenge: {
            theme: 'dark',

            eyebrow: 'Ausgangssituation',

            title: 'Ein Shopify-Store mit vielen Produktvarianten und Detailinformationen',

            text: 'Lux Hair NYC verkauft hochwertige Slavic Hair Extensions mit unterschiedlichen Kategorien, Längen, Gewichten, Texturen und Produktvarianten. Der Shopify-Store musste diese Informationen klar darstellen, damit Kunden Produkte besser vergleichen und passende Varianten schneller finden können.',

            items: [
                {
                    id: 1,
                    text: 'Viele Produktvarianten mussten übersichtlich dargestellt werden',
                },
                {
                    id: 2,
                    text: 'Produktkategorien wie K-Tip, Bulk und Tape-In sollten klar auffindbar sein',
                },
                {
                    id: 3,
                    text: 'Produktseiten mussten wichtige Details wie Länge, Gewicht, Textur und Kategorie verständlich abbilden',
                },
                {
                    id: 4,
                    text: 'Mobile Darstellung und Nutzerführung sollten auch bei vielen Produkten sauber funktionieren',
                },
                {
                    id: 5,
                    text: 'Produktpräsentation und Shop-Struktur mussten auf Online-Verkauf ausgerichtet werden',
                },
                {
                    id: 6,
                    text: 'Der Store brauchte eine technische Grundlage für weitere Produkte, Inhalte und Optimierungen',
                },
            ],

            image: challengeIMG,
            imageAlt: 'Lux Hair NYC Produktbereich Shopify',
        },

        structure: {
            theme: 'light',

            eyebrow: 'Zielsetzung',

            title: 'Eine klare Shopify-Struktur für hochwertige Hair Extensions schaffen.',

            text: 'Ziel des Projekts war es, den Lux Hair NYC Shopify-Store klarer, nutzbarer und technisch sauber aufzubauen. Besonders wichtig waren eine übersichtliche Produktstruktur, verständliche Produktseiten, mobile Darstellung und eine technische Grundlage, die weitere Produktvarianten und Kategorien unterstützt.',

            image: structureIMG,
            imageAlt: 'Lux Hair NYC Mobile Shopify Store',

            items: [
                {
                    id: 1,
                    title: 'Produktstruktur',
                    text: 'Hair-Extension-Produkte, Kategorien und Varianten sollten klar organisiert werden, damit Kunden schneller passende Produkte finden.',
                },
                {
                    id: 2,
                    title: 'Produktdetails',
                    text: 'Wichtige Informationen wie Länge, Gewicht, Textur, Kategorie und Produktvariante sollten auf Produktseiten verständlich dargestellt werden.',
                },
                {
                    id: 3,
                    title: 'Mobile Darstellung',
                    text: 'Der Shopify-Store sollte auch auf Smartphones klar funktionieren und Produktinformationen übersichtlich anzeigen.',
                },
                {
                    id: 4,
                    title: 'Technische Grundlage',
                    text: 'Shopify-Anpassungen wurden so umgesetzt, dass Produkte, Kategorien und Inhalte langfristig gepflegt und erweitert werden können.',
                },
            ],
        },

        shopifyImplementation: {
            theme: 'dark',

            eyebrow: 'Warum Nexon Digital Studio',

            title: 'Fokussierte Shopify-Umsetzung für produktstarke Online-Shops.',

            text: 'Für Lux Hair NYC lag der Fokus auf einer Shopify-Umsetzung, die viele Produktvarianten, Kategorien und Detailinformationen übersichtlich abbildet. Nexon Digital Studio unterstützte bei Store-Struktur, Produktpräsentation, mobiler Darstellung und technischen Anpassungen für den Online-Verkauf.',

            items: [
                {
                    id: 1,
                    title: 'Shopify-Expertise',
                    text: 'Technische Umsetzung von Shopify-Stores, Produktseiten, Collections und Theme-Anpassungen.',
                },
                {
                    id: 2,
                    title: 'Klare Produktstruktur',
                    text: 'Strukturierung von Kategorien, Produktvarianten und Produktdetails für eine bessere Nutzerführung.',
                },
                {
                    id: 3,
                    title: 'Saubere Store-Umsetzung',
                    text: 'Technische Anpassungen am Shopify-Store, damit Produkte, Inhalte und Verkaufsbereiche langfristig pflegbar bleiben.',
                },
            ],
        },

        implementation: {
            theme: 'light',

            eyebrow: 'Umsetzung',

            title: 'Produktseiten, Kategorien und mobile Darstellung technisch umgesetzt.',

            items: [
                {
                    id: 1,
                    eyebrow: 'Shopify Store',
                    title: 'Startseite und Produktbereiche',
                    text: 'Zentrale Bereiche des Shopify-Stores wurden technisch umgesetzt und klar auf Produktpräsentation, Orientierung und Online-Verkauf ausgerichtet.',
                },
                {
                    id: 2,
                    eyebrow: 'Produkte & Kategorien',
                    title: 'Übersichtliche Hair-Extension-Struktur',
                    text: 'Produktkategorien und Produktseiten wurden so strukturiert, dass Kunden schneller passende Hair Extensions, Varianten und Produktdetails finden.',
                },
                {
                    id: 3,
                    eyebrow: 'Mobile Optimierung',
                    title: 'Nutzbar auf allen Geräten',
                    text: 'Mobile Darstellung, Navigation und Nutzerführung wurden geprüft und angepasst, damit der Shopify-Store auch auf Smartphones verständlich nutzbar bleibt.',
                },
            ],
        },

        results: {
            theme: 'light',

            eyebrow: 'Ergebnisse',

            title: 'Ein klar strukturierter Shopify-Store für Hair Extensions',

            stats: [
                {
                    id: 1,
                    value: '10+',
                    label: 'Store-Bereiche',
                    text: 'Strukturiert und technisch umgesetzt',
                },
                {
                    id: 2,
                    value: '3',
                    label: 'Hauptkategorien',
                    text: 'K-Tip, Bulk und Tape-In',
                },
                {
                    id: 3,
                    value: '3',
                    label: 'Breakpoints',
                    text: 'Desktop, Tablet und Mobile geprüft',
                },
                {
                    id: 4,
                    value: '100%',
                    label: 'Shopify',
                    text: 'Produktstruktur, Store-Aufbau und technische Umsetzung',
                },
            ],

            testimonial: {
                quote: 'Bei diesem Projekt lag der Fokus darauf, einen produktstarken Shopify-Store übersichtlich und nutzbar aufzubauen. Besonders wichtig waren klare Kategorien, verständliche Produktdetails, mobile Nutzerführung und eine technische Grundlage, die weitere Produkte und Optimierungen sauber unterstützt.',

                labelTitle: 'Kommentar-Label:',
                label: 'Kommentar zur Umsetzung',

                author: {
                    ...projectAuthorData,
                    name: 'Dmytro Kiriachek',
                    position: 'CEO Nexon Digital Studio',
                },
            },
        },

        faq: {
            title: 'Häufige Fragen zu diesem Shopify-Projekt',

            items: [
                {
                    id: 1,
                    question: 'Was wurde bei Lux Hair NYC umgesetzt?',

                    answer: 'Bei Lux Hair NYC lag der Fokus auf technischer Shopify-Umsetzung, klarer Produktstruktur, Produktseiten, Kategorien, mobiler Darstellung und einer sauberen Store-Struktur für den Online-Verkauf.',
                },
                {
                    id: 2,
                    question: 'Für welche Unternehmen ist dieses Shopify-Projekt relevant?',

                    answer: 'Dieses Shopify-Projekt ist relevant für Online-Händler, Beauty-Marken und Shops mit vielen Produktvarianten, Kategorien oder erklärungsbedürftigen Produktdetails.',
                },
                {
                    id: 3,
                    question: 'Welche Shopify-Bereiche wurden berücksichtigt?',

                    answer: 'Im Projekt wurden zentrale Shopify-Bereiche wie Startseite, Produktseiten, Kategorien, Navigation, mobile Darstellung und technische Store-Struktur berücksichtigt.',
                },
                {
                    id: 4,
                    question: 'Warum ist eine klare Produktstruktur bei Hair Extensions wichtig?',

                    answer: 'Eine klare Produktstruktur hilft Kunden, passende Produkte schneller zu finden. Besonders bei unterschiedlichen Längen, Gewichten, Texturen und Kategorien ist eine verständliche Shopify-Struktur wichtig für Nutzerführung und Online-Verkauf.',
                },
                {
                    id: 5,
                    question: 'Kann Nexon Digital Studio ähnliche Shopify-Stores umsetzen?',

                    answer: 'Ja. Nexon Digital Studio unterstützt kleine Unternehmen, Marken und Online-Händler bei Shopify-Umsetzung, Theme-Anpassung, Produktseiten, Collections, mobiler Optimierung und technischer Store-Struktur.',
                },
                {
                    id: 6,
                    question: 'Unterstützt Nexon Digital Studio auch bestehende Shopify-Stores?',

                    answer: 'Ja. Bestehende Shopify-Stores können technisch angepasst, neu strukturiert oder für mobile Nutzung, Produktpräsentation und bessere Pflege im Shopify-Admin verbessert werden.',
                },
            ],

            button: {
                text: 'Anfrage senden',
                href: '#contacts',
            },
        },
    },
};
